import { NavigateFunction } from 'react-router-dom';

export const handleLastPath = (
  authRoles: string[],
  navigate: NavigateFunction
) => {
  const lastPath = window.localStorage.getItem('orbitLastPath');

  if (lastPath) {
    return navigate(lastPath);
  }
  if (
    authRoles.includes('enterpriseAdmin') ||
    authRoles.includes('patientRounder')
  ) {
    return navigate('/patients/census');
  }
  if (
    authRoles.includes('employeeRounder') ||
    authRoles.includes('ilobRounder')
  ) {
    return navigate('/employees/list/user');
  }
  if (authRoles.includes('validationRounder')) {
    return navigate('/validation/nlr/list');
  }
  if (authRoles.includes('aidetValidationRounder')) {
    return navigate('/validation/aidet/list');
  }
  if (authRoles.includes('bssrValidationRounder')) {
    return navigate('/validation/bssr/list');
  }
  if (authRoles.includes('safetyValidationRounder')) {
    return navigate('/validation/safety/list');
  }
  if (authRoles.includes('csrnRounder')) {
    return navigate('/support/csc/list');
  }
  if (authRoles.includes('cnedRounder')) {
    return navigate('/support/cned/list');
  }
  if (authRoles.includes('userAdmin')) {
    return navigate('/admin/users');
  }
  if (authRoles.includes('templateConfigurator')) {
    return navigate('/admin/areas');
  }
  return navigate('/404');
};
